module.exports = __webpack_public_path__ + "img/i_facebook.7db49b7c.svg";